export const CONTENT_CLASSNAME = 'floating-ui-content';
export const TOGGLE_CLASSNAME = 'floating-ui-toggle';

export enum FloatingPlacement {
  /** CENTER is a custom-implemented placement in UseFloating.ts */
  CENTER = 'CENTER',
  TOP = 'TOP',
  TOP_START = 'TOP_START',
  TOP_END = 'TOP_END',
  RIGHT = 'RIGHT',
  RIGHT_START = 'RIGHT_START',
  RIGHT_END = 'RIGHT_END',
  BOTTOM = 'BOTTOM',
  BOTTOM_START = 'BOTTOM_START',
  BOTTOM_END = 'BOTTOM_END',
  LEFT = 'LEFT',
  LEFT_START = 'LEFT_START',
  LEFT_END = 'LEFT_END',
}

export enum FloatingInteraction {
  CLICK = 'CLICK',
  CONTROLLED = 'CONTROLLED',
  HOVER = 'HOVER',
}

export interface RenderContentProps {
  /** Callback which will close the floating element and return focus to the toggle. */
  handleClose: () => void;
  /** Corresponds to 'aria-labelledby' property. See
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-labelledby */
  labelId: string;
  /** Corresponds to 'aria-describedby' property. See
   * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-describedby */
  descriptionId: string;
}

export interface OptionalCoords {
  x: number | null;
  y: number | null;
}
